var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-main",attrs:{"id":"step-base"}},[_c('b-container',[_vm._t("default",function(){return [_c('page-base')]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }